// extracted by mini-css-extract-plugin
export var wordContainer = "_mn-0";